<template>
	<div class="page-studio">

		<div class="topbar">
			<div class="topbar-left">
				<button class="button download" @click.prevent="exportTemplate"><font-icon icon="arrow-down" /> Baixar imagem</button>
				<button v-if="template.meta && template.meta.text" class="button" @click="modalActive = true">Texto de apoio</button>
			</div>

			<div class="topbar-right">
				<span class="back" @click="goBack"><font-icon :icon="['fas','times']" /></span>
			</div>

		</div>



		<main>


		<aside :class="{'input-active':inputActive,'selected-image':selectedLayer && selectedLayer.type=='image','selected-text':selectedLayer && selectedLayer.type=='text'}">

			<button @click="scrollTo(9999)" class="aside-scroll-button">
				<font-icon icon="chevron-up" />
				<!-- <font-icon icon="chevron-down" /> -->
			</button>

				<div class="options-text">
					<h3><icon-t /> Texto</h3>

					<button class="button" @click="addText"><font-icon icon="plus" /> Adicionar texto</button>
				</div>

				<div v-if="selectedLayer && selectedLayer.type=='text'" class="options-text-content">

					<div class="options-text-content-toggles">

						<div class="button-group">

							<input-font-size v-model="selectedLayer.fontSize" @openInput="openInput" @closeInput="closeInput" />
							<input-text-color v-model="selectedLayer.color" @openInput="openInput" @closeInput="closeInput" />

							<toggle-bold v-model="selectedLayer.fontWeight" :key="'bold'+selectedLayer.uid" />
							<toggle-italic v-model="selectedLayer.fontStyle" :key="'italic'+selectedLayer.uid" />

							<input-text-background v-model="selectedLayer.background" @openInput="openInput" @closeInput="closeInput" />

						</div>

						<div class="button-group">
							<toggle-text-align :key="'text'+selectedLayer.uid" v-model="selectedLayer.textAlign" />
							<input-line-height v-model="selectedLayer.lineHeight" @openInput="openInput" @closeInput="closeInput" />
							<input-letter-spacing v-model="selectedLayer.letterSpacing" @openInput="openInput" @closeInput="closeInput" />
						</div>
					</div>

					<div class="field-font">
						<p>Escolha a fonte:</p>
						<select-font :key="'font'+selectedLayer.uid" v-model="selectedLayer.fontFamily" />
					</div>
				</div>


				<div class="options-image">

					<h3>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 17.279"><g transform="translate(15.572 1.722) rotate(90)"><path class="a" fill="#fff" d="M0,11V7A1,1,0,0,1,1,6H4V1A1,1,0,0,1,5,0H9A1,1,0,1,1,9,2H6V7A1,1,0,0,1,5,8H2v3a1,1,0,0,1-2,0Z" transform="translate(0 7.072) rotate(-45)"/></g><circle class="a" fill="#fff" cx="1" cy="1" r="1" transform="translate(6 2.882)"/><g class="b" fill="none"><path class="c" stroke="none" d="M2,0H14a2,2,0,0,1,2,2V14a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z"/><path class="d" stroke="none" fill="#fff" d="M 2 2 L 2 14 L 14 14 L 14 2 L 2 2 M 2 0 L 14 0 C 15.10457038879395 0 16 0.8954296112060547 16 2 L 16 14 C 16 15.10457038879395 15.10457038879395 16 14 16 L 2 16 C 0.8954296112060547 16 0 15.10457038879395 0 14 L 0 2 C 0 0.8954296112060547 0.8954296112060547 0 2 0 Z"/></g></svg>
						Imagem
					</h3>

					<div class="custom">
							<label class="upload button">
								<input type="file" @change="onFileChange">

								<span><font-icon icon="plus" /> Enviar imagem</span>
							</label>
						</div>
				</div>

				<div v-if="selected" class="options-alignment">

					<p>Organizar</p>
					<div class="options-alignment-content">
						<div class="button-group">

							<button class="button button-icon white" @click="alignLeft"><icon-align-left /></button>
							<button class="button button-icon white" @click="alignCenter"><icon-align-center /></button>
							<button class="button button-icon white" @click="alignRight"><icon-align-right /></button>

							<button class="button button-icon white" @click="vAlignBottom"><icon-v-align-bottom /></button>
							<button class="button button-icon white" @click="vAlignCenter"><icon-v-align-center /></button>
							<button class="button button-icon white" @click="vAlignTop"><icon-v-align-top /></button>

						</div>
						<div v-if="selected && layers.length>1" class="button-group button-group-zindex">
							<button class="button button-icon white" @click="moveFront"><icon-move-front /></button>
							<button class="button button-icon white" @click="moveBehind"><icon-move-behind /></button>
						</div>
					</div>

				</div>

				<div class="option-delete">
					<button v-if="selected" class="button is-danger" @click="deleteLayer"><font-icon icon="trash" /> Excluir</button>

				</div>

		</aside>

			<div class="main-content" @click="deselect">
				<div class="preview-wrapper">
				<div class="preview">
						<div class="base" :style="{'paddingBottom':proportion+'%'}">
							<img :src="template.filename">
						</div>

						<template v-for="layer in layers" >
							<div v-if="layer.type=='image'" class="layer"
								:class="{selected:selected == layer.uid}"
								:data-uid="layer.uid"
								:style="layerStyle(layer)"
								@mousedown="mouseDownLayer($event,layer.uid)"
								@touchstart="mouseDownLayer($event,layer.uid)"
								@click.stop="selectLayer(layer.uid)"
								:key="layer.uid"
							>
								<div class="scale"
									@mousedown="mouseDownHandler"
									@touchstart="mouseDownHandler"
								></div>
							</div>

							<div v-else class="layer"
									:class="{
										selected:selected == layer.uid,
									}"
									:key="layer.uid"
									:data-uid="layer.uid"
									:style="layerStyle(layer)"
									@touchstart="mouseDownLayer($event,layer.uid)"
									@mousedown="mouseDownLayer($event,layer.uid)"
									@click.stop="selectLayer(layer.uid)"
								>
								<span v-html="layer.content.replace(/\n$/,'<br> ').replace(/\n/g,'<br>')"></span>
								<textarea v-model="layer.content"></textarea>
								<!--:contenteditable="" -->
								<!-- <div class="drag" @mousedown="mouseDownLayer($event,layer.uid)" @touchstart="mouseDownLayer($event,layer.uid)" ></div> -->
								<div class="scale scale-tr" @mousedown="mouseDownHandler" @touchstart="mouseDownHandler"></div>
								<div class="scale scale-br" @mousedown="mouseDownHandler" @touchstart="mouseDownHandler"></div>
								<div class="scale scale-bl" @mousedown="mouseDownHandler" @touchstart="mouseDownHandler"></div>
								<div class="scale scale-tl" @mousedown="mouseDownHandler" @touchstart="mouseDownHandler"></div>
							</div>
						</template>


						<!-- <div v-if="upload" class="placeholder"></div> -->
						<!-- <img class="uploaded" v-if="upload" :src="upload"> -->
						<!-- <div  v-show="upload && !grab" class="scaleHandle"><font-icon :icon="['fas','arrows-alt-h']" /></div> -->

					</div>
			</div>
			</div>

		</main>

		<div class="modal is-active modal-exit" v-if="modalExit" >
			<div class="modal-background"></div>
			<div class="modal-content">
				<button class="modal-close is-large" aria-label="close" @click="modalExit = false"></button>
				<section class="modal-card-body">

					<h4>Você deseja mesmo sair da edição?</h4>
					<p>Sua imagem não ficará salva. </p>
					<p>Por enquanto, nosso sistema não oferece a opção de salvar para continuar editando mais tarde.</p>

					<div class="button-group">
						<button class="button is-text" @click="modalExit = false">Voltar</button>
						<button class="button is-danger" @click="confirmExit">Sair</button>
					</div>

				</section>
			</div>

		</div>


		<div class="modal is-active" v-if="modalActive" >
			<div class="modal-background"></div>
			<div class="modal-content">
				<button class="modal-close is-large" aria-label="close" @click="modalActive = false"></button>
				<section class="modal-card-body">

					<div class="field">
						<label class="label">Texto para usar na postagem</label>
						<div class="control">
							<textarea v-model="template.meta.text" readonly class="textarea"></textarea>
						</div>
					</div>

					<button class="button is-success" @click="clipboard">Copiar texto</button>

				</section>

			</div>

		</div>

	</div>
</template>
<style>
	.page-studio .button { text-transform: none; font-size:1rem; background-color:#454573; border-color: transparent; color: #fff; font-weight:400; letter-spacing: 0; height: 2.4em; line-height: 1; }
	.page-studio .button.white { background-color:#fff; color:#333; border:1px solid #6B6CB1; }
	.page-studio .button-icon { padding:calc(0.375em - 1px); min-width: 40px; }
	.page-studio .button svg { width: 0.875em; display: inline-block; font-size: inherit; height: 1em; overflow: visible; vertical-align: -0.125em; }
	.page-studio .button:focus { box-shadow:none;}

	@media(max-width:991px){

		.vc-chrome-hue-wrap .vc-hue-picker, .vc-chrome-alpha-wrap .vc-alpha-picker{
			width: 20px !important;
			height: 20px !important;
			border-radius: 10px !important;
			transform: translate(-9px ,-6px) !important;
		}

		.slider-container {
			position: fixed !important;
			right: 0;
			left: 0;
			margin-top: 5px;
			width: auto !important;
			padding: 29px 12px !important;
		}
		.slider-container input::-webkit-slider-thumb { width:25px !important; height:25px !important; }

		.field-font .options{
			bottom: 0px;
			top: initial;
		}
	}

</style>

<style scoped>

	@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,700;1,400;1,700&display=swap');
	@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,700;1,400;1,700&display=swap');
	@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;1,400;1,700&display=swap');
	@import url('https://fonts.googleapis.com/css2?family=Oswald:ital,wght@0,400;0,700;1,400;1,700&display=swap');
	@import url('https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,400;0,700;1,400;1,700&display=swap');
	@import url('https://fonts.googleapis.com/css2?family=Josefin+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap');
	@import url('https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;700&display=swap');

	@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap');
	@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;700&display=swap');
	@import url('https://fonts.googleapis.com/css2?family=Prata&display=swap');
	@import url('https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,400;0,700;1,400;1,700&display=swap');
	@import url('https://fonts.googleapis.com/css2?family=Pacifico&display=swap');
	@import url('https://fonts.googleapis.com/css2?family=Indie+Flower&display=swap');
	@import url('https://fonts.googleapis.com/css2?family=Sacramento&display=swap');
	@import url('https://fonts.googleapis.com/css2?family=Arvo:ital,wght@0,400;0,700;1,400;1,700&display=swap');
	@import url('https://fonts.googleapis.com/css2?family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&display=swap');


	.page-studio { position: fixed; top: 0; z-index: 99990; background: #0F0F1A; width: 100%; height: 100%; left: 0; display: flex; flex-direction: column; }
	.button-group  {  display:flex; align-items: center; position: relative; }
	.button-group > * { margin-right:10px;}
	.button-group > :last-child { margin-right:0px;}
	.button-group + .button-group { margin-top:10px;}

	/* .button { text-transform: none; font-size:1rem; background-color:#454573; border-color: transparent; color: #fff; font-weight:400; letter-spacing: 0; height: 2.4em; line-height: 1; }
	.button.white { background-color:#fff; border:1px solid #6B6CB1; }
	.button svg { width: 0.875em; display: inline-block; font-size: inherit; height: 1em; overflow: visible; vertical-align: -0.125em; margin-right: 5px;}
	.button:focus { box-shadow:none;} */
	.button:not(.download) svg { color:#6B6CB1 }
	.button:not(.button-icon) svg { margin-right:5px; }


	.topbar { display: flex; height:65px; border-bottom: 1px solid rgba(69, 69, 115, 0.5); }
		.topbar-left { padding:15px 25px; flex: 400px 0 0; background:#1F1F36; }
			.button.download { background-color:#7855F2; color:#fff; margin-right:10px; }

		.topbar-right {  padding:15px 25px; flex:1 0; display: flex; justify-content: flex-end; align-items: center; }
			.topbar-right .back{ color:#454573; cursor: pointer; font-size: 1.5em; }


	main { flex:1 0; display: flex; height:100%; overflow: hidden; }

	aside { flex: 400px 0 0; background:#1F1F36; padding:25px; overflow: auto; height:100%; }
		.aside-scroll-button { display:none; position: absolute; top:0; left:50%; transform: translate(-50%,-50%); color:#fff; background: #7855F2; border: none; width: 25px; height: 25px; border-radius: 100%; }
		aside h3 { color:#fff; padding-bottom:7px; border-bottom:1px solid #454573; margin-bottom:15px; }
		aside h3 svg { margin-right:5px; width: 16px; display: inline-block; font-size: inherit; height: 17px; overflow: visible; vertical-align: -0.125em; }


	aside .options-text{ margin-bottom:30px; }
		.options-text > div { margin-top:20px; }
			/* .options-text .button-group { margin-bottom:10px; } */
			.field-size { display:inline-block; height: 2.75em; font-size: 0.85rem; width:2.75em; border-radius: 4px; border:1px solid #6B6CB1; }
			.field-size input { color:#fff; background: none; padding: 0; border: none; width: 100%; height: 100%; text-align: center; }
				.field-size input::-webkit-outer-spin-button, .field-size input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
				input[type=number] { -moz-appearance: textfield; }
			.field-color { display:inline-block; height: 2.75em; font-size: 0.85rem; background-color:#fff; width:2.75em; border-radius: 4px; border:1px solid #6B6CB1; padding:4px; }
				.field-color input { background: none; padding: 0; border: none; width: 100%; height: 100%; border-radius: 3px; }
			.field-font { margin-top:10px; margin-bottom:20px; }
				.field-font p{ margin-bottom:5px; color:#fff; }
				.field-font select{}

		.options-image { margin-bottom:30px; }
			label.upload {  cursor: pointer; text-align:center; border-width: 2px; border-style: dashed; }
			label.upload input{ display: none; }

		.options-alignment { margin-bottom:20px;}
		.options-alignment .button svg {
			width: 22px;
			height: 22px;
			margin-right:0;
		}

		.options-alignment p {color:#fff; margin:0 0 5px 0;}

		.button-group-zindex .button svg{
			width:18px;
			height:15px;
		}

		.option-delete .button { color:#fff; }
		.option-delete .button svg { color:#fff; }


	.main-content { flex:1 0; padding:35px; overflow: auto; height:100%;  }

	@media(max-width:991px){
		.topbar { justify-content: space-between; background:#1F1F36; }
		.topbar-left { padding:15px; flex: 100% 0 1;}
		.topbar-right { padding:15px 15px 15px 0;}

		main {display: block; height: auto; overflow: auto; }

		.main-content { height: calc(100vh - 65px - 60px); padding: 15px; /* align-items: flex-start; */ }

		aside { padding:10px 15px; position: absolute; height:auto; left:0; right:0; bottom:0; z-index: 2; display:flex; overflow: visible; }

		aside .options-text { margin:0 10px 0 0; }
		.options-text h3 { display:none ;}
		aside .options-image { margin:0; }
		.options-image h3 { display:none ;}

		aside[class*="selected"] { display:block; }
		aside[class*="selected"] .options-text { display:none }
		aside[class*="selected"] .options-image { display:none }

		.button-group + .button-group { margin:0 0 0 10px; }

		.options-text-content { }
		.options-text-content-toggles { display: flex; overflow: visible; overflow-x: auto; white-space: nowrap; position: relative; }
		.options-text-content-toggles::-webkit-scrollbar { display:none;opacity:.1; width:4px; height:4px; background:transparent; }
		.options-text-content-toggles:hover::-webkit-scrollbar { opacity:1; }
		.options-text-content-toggles::-webkit-scrollbar-thumb {  border-radius:10px;background:rgba(255,255,255,.4); }
		.options-text-content-toggles::-webkit-scrollbar-track { margin:0; }

		.field-font{ position: relative; margin:0 0 10px 0; }

		.options-alignment { display: none;}
		aside.selected-image .options-alignment { display: block; }
		.options-alignment-content { display:flex; overflow: visible; overflow-x: auto; }
		.options-alignment-content::-webkit-scrollbar { display:none;opacity:.1; width:4px; height:4px; background:transparent; }
		.options-alignment-content:hover::-webkit-scrollbar { opacity:1; }
		.options-alignment-content::-webkit-scrollbar-thumb {  border-radius:10px;background:rgba(255,255,255,.4); }
		.options-alignment-content::-webkit-scrollbar-track { margin:0; }


		.option-delete{}
		/* .aside-scroll-button { display: block; } */

		aside.input-active{}
		aside.input-active .options-text-content-toggles{
			overflow-x: hidden;
		}



	}


	.rotate-45 { transform: rotate(45deg);}

	.preview-wrapper{
		padding:4px;
		border:1px solid #454573;
		border-radius:2px;
		position: relative; width:100%; height:100%;
		margin:0 auto;
		display: flex; justify-content: center; align-items: center;
	}
	.preview{ position: relative; width:100%; height:100%; overflow: hidden; }

	.preview .base{ position: relative; width:100%; padding-bottom:100%;}
	.preview .base img{ position: absolute;top:0; left:0; width:100%; height:100%; display: block;}

		.layer { outline: none; position:absolute; background-position:center; background-repeat:no-repeat; background-size:contain;
			white-space: pre-wrap;
			overflow-wrap: break-word;
			min-height: 1em;
			display:flex;
			align-items: center;
		}
			.layer .drag { cursor:pointer; position: absolute; top:50%; transform: translateY(-50%); width:20px; height:20px; background-color:#fff; left:-22px; opacity:0.5;}
			.layer .drag:hover { opacity:1;}

			.layer .scale { width: 12px; height: 12px; position: absolute; background: #fff; border: 1px solid #45A1E6; border-radius: 100%; cursor: pointer; opacity:1; }
			.layer .scale-tr { top: -6px; right: -6px; }
			.layer .scale-br { bottom: -6px; right: -6px; }
			.layer .scale-bl { bottom: -6px; left: -6px; }
			.layer .scale-tl { top: -6px; left: -6px; }
			.layer .scale:hover { opacity:1;}

			.layer .scale, .layer .drag { display:none; }

			.layer.selected span{ display:none; }
			.layer.selected textarea{ display:block; }

			.layer span { display:block; width:100%; }
			.layer textarea {
				/* position: absolute; top:0; left:0; width:100%; height:100%; */
				/* opacity: 0; */
				/* visibility: hidden; */
				color:inherit;
				font-family:inherit;
				font-size:inherit;
				font-weight:inherit;
				font-style:inherit;
				text-align:inherit;
				line-height:inherit;
				letter-spacing:inherit;
				border:0;
				background:none;
				overflow: hidden;
				outline:none;
				display:none;

			}

		.layer.selected { outline:solid 1px #45A1E6}
		.layer.selected .scale, .layer.selected .drag { display:block;}




	.modal-close { position: absolute; top:10px; right:10px; }
	.modal-close:hover { background-color: rgba(0, 0, 0, 0.1); }
	.modal-close:after,.modal-close:before{ background-color:#B2B2BD;}

	.modal-exit { }
	.modal-exit .modal-content{ max-width:320px }
	.modal-exit .modal-card-body { padding:60px 20px 40px; text-align:center; color: #333; }
	.modal-exit h4 { margin-bottom:20px; font-weight:bold;}
	.modal-exit  p { margin-bottom:10px; }
	.modal-exit .button-group { margin-top:40px; justify-content: center;}
	.modal-exit .button { min-width:75px;}
	.modal-exit .is-text { color:#333; background:none;}

	@media (min-width:992px){
		.preview, .preview * { user-select: none; }
	}

</style>

<script>
import ToggleTextAlign from './elements/ToggleTextAlign'
import ToggleBold from './elements/ToggleBold'
import ToggleItalic from './elements/ToggleItalic'
import InputFontSize from './elements/InputFontSize';
import InputTextColor from './elements/InputTextColor'
import InputTextBackground from './elements/InputTextBackground'

import InputLineHeight from './elements/InputLineHeight';
import InputLetterSpacing from './elements/InputLetterSpacing';

import SelectFont from './elements/SelectFont'

import IconT from './icons/T';
import IconAlignLeft from './icons/AlignLeft';
import IconAlignCenter from './icons/AlignCenter';
import IconAlignRight from './icons/AlignRight';
import IconVAlignTop from './icons/VAlignTop';
import IconVAlignCenter from './icons/VAlignCenter';
import IconVAlignBottom from './icons/VAlignBottom';
import IconMoveBehind from './icons/MoveBehind';
import IconMoveFront from './icons/MoveFront';


export default {
	props: ['id', 'post'],
	components:{
		ToggleTextAlign,
		ToggleBold,
		ToggleItalic,
		InputFontSize,
		InputTextColor,
		InputTextBackground,

		InputLineHeight,
		InputLetterSpacing,

		SelectFont,

		IconT,
		IconAlignLeft,
		IconAlignCenter,
		IconAlignRight,
		IconVAlignTop,
		IconVAlignCenter,
		IconVAlignBottom,
		IconMoveBehind,
		IconMoveFront,
	},
	data () {
		return {

			template: {
				name: '',
				filename: '',
				meta: {}
			},

			layers:[
			],

			selected:null,
			contentEditable:false,

			grab: false,
			scale: false,

			rect: { x: 0, y: 0 },
			offset: { x: 0, y: 0 },
			origin: { x: 0, y: 0 },

			outputUrl: '',

			inputActive:0,
			modalActive:false,
			modalExit:false,
		};
	},
	computed: {
		proportion () {
			return this.template.meta.height / this.template.meta.width * 100;
		},
		selectedLayer(){
			return this.layers.find(item=>item.uid == this.selected);
		},
	},
	methods: {

		openInput(){
			this.inputActive += 1;
		},
		closeInput(){
			this.inputActive -= 1;
		},
		scrollTo(pos){
			document.querySelector('main').scrollTo(0,pos);
		},


		deleteLayer(){
			var index = this.layers.indexOf(this.selectedLayer);
			this.layers.splice(index,1);
			this.deselect();
		},

		vAlignTop(){
			var layer = this.selectedLayer;
			layer.top = 0;
		},
		vAlignCenter(){
			var layer = this.selectedLayer;
			var layerHeight = document.querySelector('.layer.selected').offsetHeight;
			var totalHeight = document.querySelector('.preview').offsetHeight;
			layer.top = (totalHeight / 2) - (layerHeight /2);
		},
		vAlignBottom(){
			var layer = this.selectedLayer;
			var layerHeight = document.querySelector('.layer.selected').offsetHeight;
			var totalHeight = document.querySelector('.preview').offsetHeight;
			layer.top = totalHeight - layerHeight;
		},
		alignLeft(){
			var layer = this.selectedLayer;
			layer.left = 0;
		},
		alignCenter(){
			var layer = this.selectedLayer;
			var totalWidth = document.querySelector('.preview').offsetWidth;
			layer.left = (totalWidth / 2) - (layer.width /2);
		},
		alignRight(){
			var layer = this.selectedLayer;
			var totalWidth = document.querySelector('.preview').offsetWidth;
			layer.left = totalWidth - layer.width;
		},
		moveFront(){
			var layer = this.selectedLayer;
			layer.zindex = this.layers.reduce((carry,item)=>{ return Math.max(carry,item.zindex); },1) + 1;
		},
		moveBehind(){
			this.layers.forEach( item => ++item.zindex );
			var layer = this.selectedLayer;
			layer.zindex = 1;
		},

		mouseDownLayer(e,uid){

			if(this.selected==uid && this.selectedLayer.type=='text'){
				//allow text selection drag
				return;
			}
			this.selected = uid;

			if(this.selected!=uid) return;
			this.handleDragStart(e);
		},

		mouseDownHandler(e){
			this.handleScaleStart(e);
		},

		clipboard (evt) {
			var button = evt.target;
			var originalTxtButton = button.innerText;
			var el = document.querySelector('textarea');

			// Copy textarea, pre, div, etc.
			if (document.body.createTextRange) {
				// IE
				var textRange = document.body.createTextRange();
				textRange.moveToElementText(el);
				textRange.select();
				textRange.execCommand('Copy');

				originalTxtButton = button.innerText;
				button.innerText = 'Copiado!';
				setTimeout(() => { button.innerText = originalTxtButton; }, 2000);
			} else if (window.getSelection && document.createRange) {
				// non-IE
				var editable = el.contentEditable; // Record contentEditable status of element
				var readOnly = el.readOnly; // Record readOnly status of element
				el.contentEditable = true; // iOS will only select text on non-form elements if contentEditable = true;
				el.readOnly = true; // iOS will not select in a read only form element // Version 1.2c - Changed from false to true; Prevents keyboard from appearing when copying from textarea
				var range = document.createRange();
				range.selectNodeContents(el);
				var sel = window.getSelection();
				sel.removeAllRanges();
				sel.addRange(range); // Does not work for Firefox if a textarea or input
				if (el.nodeName == 'TEXTAREA' || el.nodeName == 'INPUT') {
					el.select(); // Firefox will only select a form element with select()
				}
				// if (el.setSelectionRange && navigator.userAgent.match(/ipad|ipod|iphone/i)) // Version 1.2c - iOS 12 might be defaulting to desktop mode so removed
				if (el.setSelectionRange) { // Version 1.2c - iOS 12 might be defaulting to desktop mode and no longer has iphone in user agent
					el.setSelectionRange(0, 999999); // iOS only selects "form" elements with SelectionRange
				}
				el.contentEditable = editable; // Restore previous contentEditable status
				el.readOnly = readOnly; // Restore previous readOnly status
				if (document.queryCommandSupported('copy')) {
					var successful = document.execCommand('copy');
					if (successful) {
						button.innerText = 'Copiado!';
						setTimeout(() => { button.innerText = originalTxtButton; }, 2000);
						sel.removeAllRanges();
					} else {
						// alert("Pressione CTRL+C para copiar");
					}
				} else {
					if (!navigator.userAgent.match(/ipad|ipod|iphone|android|silk/i)) {
						// alert("Pressione CTRL+C para copiar");
					}
				}
			}
		},

/*		loadFont(font){
			var fontTag = this.fontList.find(item=>item.name==font);

			var elm =  document.createElement('div');
			elm.innerHTML = fontTag.tag;
			document.body.appendChild(elm);
		},
*/
		layerStyle(layer){
			var style={
				top:layer.top+'px',
				left:layer.left+'px',
				width:layer.width+'px',
			}
			style['z-index'] = layer.zindex;
			if(layer.type=='image'){
				style.height = layer.height+'px';
				style['background-image']=`url(${layer.content})`;
			}
			if(layer.type=='text'){
				style['font-family'] = layer.fontFamily;
				style['font-size'] = layer.fontSize+'px';
				style['font-weight'] = layer.fontWeight;
				style['font-style'] = layer.fontStyle;
				style['color'] = layer.color;
				style['text-align'] = layer.textAlign;
				style['letter-spacing'] = layer.letterSpacing+'px';
				style['line-height'] = layer.lineHeight;
				style['background-color'] = layer.background;
			}
			return style;
		},

		newUid(){
			return 'id'+(new Date().getTime());

		},
		selectLayer(uid){
			this.$nextTick(()=>{
				if(this.selected==uid) {
					this.contentEditable = true;
					//var textarea = document.querySelector('layer.selected textarea')
					//if(textarea) textarea.focus();
					return;
				}
				this.selected = uid;
				this.contentEditable = false;

			});
		},
		deselect(){
			this.selected = null;
			this.inputActive = 0;
		},
		addText(){
			var totalWidth = document.querySelector('.preview').offsetWidth;
			var totalHeight = document.querySelector('.preview').offsetHeight;

				var uid = this.newUid();
				this.layers.push({
					uid:uid,
					type:'text',
					content:'Escreva o texto aqui',
					left:(totalWidth / 4),
					top:(totalHeight / 4),
					width:totalWidth / 2,
					zindex:this.layers.length+1,
					fontSize:30,
					fontFamily:'Roboto',
					fontWeight:'normal',
					fontStyle:'normal',
					color:'#ffffff',
					textAlign:'center',
					letterSpacing:0,
					lineHeight:1.3,
					background:'rgba(255,255,255,0)',
				});
				this.selectLayer(uid);
				this.scrollTo(0);

		},
		onFileChange (e) {
			var files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;
			var file = files[0];
			var reader = new FileReader();
			var img = new Image();
			reader.onload = (re) => {
				img.onload = () => {
					var width = img.width;
					var height = img.height;

					var max_width = this.template.meta.width;
					var max_height = this.template.meta.height;

					if (width > height) {
						if (width > max_width) {
							height *= max_width / width;
							width = max_width;
						}
					} else {
						if (height > max_height) {
							width *= max_height / height;
							height = max_height;
						}
					}

					var canvas = document.createElement('canvas');
					var ctx = canvas.getContext('2d');

					canvas.width = width;
					canvas.height = height;
					ctx.drawImage(img, 0, 0, width, height);

					if(file.name.match(/jpe?g$/i)){
						var dataurl = canvas.toDataURL('image/jpeg',0.95);
					} else {
						var dataurl = canvas.toDataURL('image/png');
					}


					var totalWidth = document.querySelector('.preview').offsetWidth;
					var totalHeight = document.querySelector('.preview').offsetHeight;

					var uid = this.newUid();

					var layer = {
						uid:uid,
						type:'image',
						zindex:this.layers.length+1,
						content:dataurl,
						left:(totalWidth / 4),
						top:(totalHeight / 2),
						width:totalWidth / 2,
						height:height / (width / (totalWidth / 2)),
					};
					layer.proportion = width/height;
					this.layers.push(layer);

					this.selectLayer(uid);
					this.scrollTo(0);

					//this.updateScaleHandlePosition(this.uploadedElm.width, calculatedHeight);
				};
				img.src = re.target.result;
			};
			reader.readAsDataURL(file);
		},


		exportTemplate () {

			alert('buy me a beer first 😂');
			return;

			let outputWidth = this.template.meta.width;
			let outputHeight = this.template.meta.height;

			let currentScale = document.querySelector('.preview').offsetWidth / outputWidth;

			var data = {
				// html:document.querySelector('.preview').outerHTML,
				outputWidth:outputWidth,
				outputHeight:outputHeight,
				base:this.template.filename,
				layers:this.layers,
				scale:currentScale,
			}

			this.$http.post('marketing/generate', data).then(res => {
				this.outputUrl = res.data;
				window.location = '/api/marketing/download?filename=' + res.data;

			}).catch(res => {
				console.log(res);
			});
		},

		goBack () {
			if(this.layers.length){
				this.modalExit = true;
				return;
			}
			this.$router.push({ name: 'marketing' });
		},

		confirmExit(){
			this.modalExit = false;
			this.$router.push({ name: 'marketing' });
		},


		handleDragStart (e) {

			//e.preventDefault();
			//e.stopPropagation();

			this.rect = {
				x:this.selectedLayer.left,
				y:this.selectedLayer.top,
			}

			this.origin.x = e.clientX || e.touches[0].clientX;
			this.origin.y = e.clientY || e.touches[0].clientY;

			this.grab = true;
			return false;
		},
		handleDragMove (e) {
			e.preventDefault();
			e.stopPropagation();
			let clientX = e.clientX || e.touches[0].clientX;
			let clientY = e.clientY || e.touches[0].clientY;

			var layer = this.selectedLayer;

			layer.left = this.rect.x + (clientX - this.origin.x);
			layer.top = this.rect.y + (clientY - this.origin.y);

			return false;
		},
		handleDragEnd () {

			//e.preventDefault();
			this.grab = false;
		},

		handleScaleStart (e) {
			e.preventDefault();
			e.stopPropagation();
			this.rect = {
				x:this.selectedLayer.left,
				y:this.selectedLayer.top,
				width:this.selectedLayer.width,
				height:this.selectedLayer.height,
			}
			this.origin.x = e.clientX || e.touches[0].clientX;
			this.origin.y = e.clientY || e.touches[0].clientY;
			this.scale = true;

			return false;
		},
		handleScaleMove (e) {
			e.preventDefault();
			e.stopPropagation();
			let clientX = e.clientX || e.touches[0].clientX;
			let clientY = e.clientY || e.touches[0].clientY;

			var layer =this.selectedLayer;
			layer.width = this.rect.width + (clientX - this.origin.x);
			layer.height = this.rect.height + (clientY - this.origin.y);


			//this.updateScaleHandlePosition();
		},
		handleScaleEnd (e) {
			e.preventDefault();
			this.scale = false;
		},

		adjustPreviewSize(){
			var wrapperElm = document.querySelector('.preview-wrapper');

			//back to 100%
			wrapperElm.style.width = '';
			wrapperElm.style.height = '';

			var contentWidth = wrapperElm.offsetWidth;
			var contentHeight = wrapperElm.offsetHeight;

			var resultWidth = this.template.meta.width;
			var resultHeight = this.template.meta.height;
			var sizeProportion = resultWidth / resultHeight;

			if(this.template.meta.width > contentWidth){
				resultWidth = contentWidth;
				resultHeight = resultWidth / sizeProportion;
			}
			if(resultHeight > contentHeight){
				resultHeight = contentHeight;
				resultWidth = resultHeight * sizeProportion;
			}

			wrapperElm.style.width = resultWidth+'px';
			wrapperElm.style.height = resultHeight+'px';
		}
	},

	mounted () {

		if (this.post) {
			this.template = this.post;
			this.adjustPreviewSize();
		} else {
			console.log('erro go back');
			this.goBack();
		}

/*
		document.querySelector('#app').addEventListener('mousedown', (e) => {
			if (e.target == this.uploadedElm) return this.handleDragStart(e);
			if (e.target == this.scaleHandleElm) return this.handleScaleStart(e);
		});
		*/
		document.querySelector('#app').addEventListener('mouseup', (e) => {
			if (this.grab) return this.handleDragEnd(e);
			if (this.scale) return this.handleScaleEnd(e);
		});
		document.querySelector('#app').addEventListener('mousemove', (e) => {
			if (this.grab) return this.handleDragMove(e);
			if (this.scale) return this.handleScaleMove(e);
		});

/*		document.querySelector('#app').addEventListener('touchstart', (e) => {
			if (e.target == this.uploadedElm) return this.handleDragStart(e);
			if (e.target == this.scaleHandleElm) return this.handleScaleStart(e);
		});
		*/
		document.querySelector('#app').addEventListener('touchend', (e) => {
			if (this.grab) return this.handleDragEnd(e);
			if (this.scale) return this.handleScaleEnd(e);
		});
		document.querySelector('#app').addEventListener('touchmove', (e) => {
			if (this.grab) return this.handleDragMove(e);
			if (this.scale) return this.handleScaleMove(e);
		});


		window.ctrlDown = false;

        var ctrlKey = 17;
        var cmdKey = 91;
        var vKey = 86;
		var cKey = 67;

		document.addEventListener('keydown',(e)=>{
			if (e.keyCode == ctrlKey || e.keyCode == cmdKey) window.ctrlDown = true;
			if (window.ctrlDown && (e.keyCode == cKey)) console.log("Document catch Ctrl+C");
			if (window.ctrlDown && (e.keyCode == vKey)) console.log("Document catch Ctrl+V");
		});
		document.addEventListener('keyup',(e)=>{
			if (e.keyCode == ctrlKey || e.keyCode == cmdKey) window.ctrlDown = false;
		});


	}
};
</script>
